import { useSelector } from 'react-redux'
import { selectUsuarioActual } from '../../redux/slices/autenticacion/autenticacion.slice'

///* TODO AMF [18/04/2023]: Eliminar arreglo de test de roles de usuario */
// `ROLES_DEL_USUARIO` es un arreglo de prueba/ejemplo historico.
// El contrato real de permisos en runtime usa `usuario.roles` del estado de autenticacion.
export const ROLES_DEL_USUARIO = [
  'ROLE_SITIOS_LECTURA',
  'ROLE_AUTORIZACIONES_LECTURA',
  'ROLE_CONDICIONANTES_LECTURA',
  'ROLE_TAREAS_LECTURA',
  'ROLE_CALENDARIO_CREAR',
]

const useHasPermiso = () => {
  const usuario = useSelector(selectUsuarioActual)

  /**
   * Verifica si el usuario tiene al menos uno de los roles requeridos.
   *
   * Esta funcion controla visibilidad en rutas, menus y acciones. No sustituye
   * la autorizacion del backend; solo evita mostrar opciones no permitidas en UI.
   */
  const hasPermiso = (role: string[]) => {
    return usuario?.roles.some((r: string) => role.includes(r))
  }

  return { hasPermiso }
}

export default useHasPermiso
